import React from 'react';
import components from '../components';

if (typeof components.T != 'function' && typeof components.T != 'object')
	components.T = React.Fragment;

export default components.T;
